import React from 'react';
import { Button } from '../ui/button';
import { Checkbox } from '../ui/checkbox';
import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Columns3 } from 'lucide-react';

export const ColumnsPicker = ({ columns, visibleKeys, onToggle, testId = 'columns-picker' }) => (
  <Popover>
    <PopoverTrigger asChild>
      <Button variant="outline" size="sm" data-testid={`${testId}-btn`}>
        <Columns3 className="w-4 h-4 mr-2" />Columns
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-64" align="end" data-testid={`${testId}-popover`}>
      <p className="text-xs font-medium text-muted-foreground mb-2">Show/hide columns</p>
      <div className="space-y-2 max-h-72 overflow-y-auto">
        {columns.map(c => (
          <label key={c.key} className="flex items-center gap-2 text-sm cursor-pointer" data-testid={`${testId}-toggle-${c.key}`}>
            <Checkbox checked={visibleKeys.includes(c.key)} onCheckedChange={() => onToggle(c.key)} />
            {c.label}
          </label>
        ))}
      </div>
    </PopoverContent>
  </Popover>
);

export default ColumnsPicker;
